import * as R from 'ramda';

const {CampaignContentWorkflow} = window.sn.enums;

const workflowsByName = {
    [CampaignContentWorkflow.SOCIAL_NATIVE]: {
        contentOnly: false,
        displayUndistributedContent: true,
        genericContent: false,
        partitionContent: true,
        requiresBrandPreapproval: false,
        usesBrandContentApprovalQueue: false,
        requiresCaption: true,
        allowsCaptionOverride: false,
        requiresPreapproval: false,
        requiresDistribution: true,
        showInternalVisiblePosts: false,
        oneStarApprovalMeansDoNotDistribute: false
    },
    [CampaignContentWorkflow.CONTENT_PREAPPROVAL]: {
        contentOnly: false,
        displayUndistributedContent: true,
        genericContent: true,
        partitionContent: true,
        requiresCaption: true,
        allowsCaptionOverride: false,
        requiresPreapproval: true,
        requiresDistribution: true,
        requiresBrandPreapproval: true,
        usesBrandContentApprovalQueue: false,
        showInternalVisiblePosts: true,
        oneStarApprovalMeansDoNotDistribute: false
    },
    [CampaignContentWorkflow.CONTENT_INTERNAL_PREAPPROVAL]: {
        contentOnly: false,
        displayUndistributedContent: false,
        genericContent: true,
        partitionContent: true,
        requiresBrandPreapproval: false,
        usesBrandContentApprovalQueue: false,
        requiresCaption: true,
        allowsCaptionOverride: false,
        requiresPreapproval: true,
        requiresDistribution: true,
        showInternalVisiblePosts: true,
        oneStarApprovalMeansDoNotDistribute: true
    },
    [CampaignContentWorkflow.CONTENT_ONLY]: {
        contentOnly: true,
        displayUndistributedContent: true,
        genericContent: true,
        partitionContent: false,
        requiresBrandPreapproval: false,
        usesBrandContentApprovalQueue: false,
        requiresCaption: false,
        allowsCaptionOverride: true,
        requiresPreapproval: false,
        requiresDistribution: false,
        showInternalVisiblePosts: false,
        oneStarApprovalMeansDoNotDistribute: false
    },
    [CampaignContentWorkflow.OPS_AND_BRAND_PREAPPROVAL]: {
        contentOnly: false,
        displayUndistributedContent: true,
        genericContent: true,
        partitionContent: true,
        requiresBrandPreapproval: true,
        usesBrandContentApprovalQueue: true,
        requiresCaption: true,
        allowsCaptionOverride: false,
        requiresPreapproval: true,
        requiresDistribution: true,
        showInternalVisiblePosts: false,
        oneStarApprovalMeansDoNotDistribute: false
    }
};

export const getCampaignWorkflow = R.propOr({}, R.__, workflowsByName);

export const workflowsBy = R.pickBy(R.__, workflowsByName);



// WEBPACK FOOTER //
// ./common/workflows.js